export default function Ads({ activeArtistId }) {
  return <div style={{ padding:'28px 30px', position:'relative', zIndex:1 }}><h1 style={{ fontSize:22, fontWeight:800 }}>Ads</h1><p style={{ color:'var(--muted)', marginTop:8 }}>Coming soon — ask to build this page out!</p></div>;
}